import { Button, TableActionBar, TableActionBarOverlay } from '@amzn/meridian';
import type { FC, ReactNode } from 'react';

export type LDAPPermissionsTableActionBarProps = {
  checkedCount: number;
  onCloseActionBar: () => void;
  onRemoveBulkAction: () => void;
  children?: ReactNode;
};

export const LDAPPermissionsTableActionBar: FC<LDAPPermissionsTableActionBarProps> = ({
  checkedCount,
  onCloseActionBar,
  onRemoveBulkAction,
  children,
}) => (
  <TableActionBar
    data-cy="ldap-permissions-table-action-bar"
    widths={[
      'fill',
    ]}
  >
    {checkedCount > 0 ? (
      <TableActionBarOverlay
        closeLabel="Cancel"
        label={
          <span>
            <strong>{checkedCount}</strong> {`group${checkedCount === 1 ? '' : 's'} `}
            selected
          </span>
        }
        onClose={onCloseActionBar}
      >
        <Button onClick={onRemoveBulkAction} type="link">
          Remove
        </Button>
      </TableActionBarOverlay>
    ) : null}
    {children}
  </TableActionBar>
);
